import { h } from 'preact';
import Text from 'widget_main/components/Text';
import { formatAccessibleTimestamp } from 'widget_main/components/TimeAgo/accessibilityHelpers';
import timeAgoMessages from 'widget_main/components/TimeAgo/messages';
import { useTranslations } from 'i18n/hooks';
import styles from './chatMessage.scss';
import messages from './messages';

interface MessageSenderAnnouncementProps {
  isOutbound?: boolean;
  senderName?: string;
  timestamp?: string;
}

const MessageSenderAnnouncement = ({
  isOutbound,
  senderName,
  timestamp,
}: MessageSenderAnnouncementProps) => {
  const timeAgoTranslations = useTranslations(timeAgoMessages);
  const accessibleTime = formatAccessibleTimestamp(
    timestamp,
    timeAgoTranslations.timeAgoJustNow,
  );

  if (isOutbound) {
    return (
      <span className={styles.visuallyHidden}>
        <Text
          id="outboundMessageAriaLabel"
          defaultMessage={messages.outboundMessageAriaLabel}
          fields={{ time: accessibleTime }}
        />
      </span>
    );
  }

  return (
    <span className={styles.visuallyHidden}>
      <Text
        id="inboundMessageAriaLabel"
        defaultMessage={messages.inboundMessageAriaLabel}
        fields={{
          name: senderName || '',
          time: accessibleTime,
        }}
      />
    </span>
  );
};

export default MessageSenderAnnouncement;
